// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"178":"notfound","180":"video","594":"about"}[chunkId] + "." + {"178":"70827b55","180":"854c6f1e","594":"918819ea"}[chunkId] + ".js";
};